import React, {Component} from 'react';
import AdminPanel from '../components/admin/AdminPanel';
// import LocationManagement from "../components/location_manager/LocationManagement";
import Locator from "../components/locator/Locator";
import MobileLandscapeMessage from '../components/MobileLandscapeMessage';
import IEOverlay from '../components/IEOverlay';


class MainRouter extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isInLandscape: this.isInLandscape()
        }
    }

    componentWillMount() {
        window.onorientationchange = this.onOrientationChange;
    }

    isInLandscape = () => {
        return window.orientation != null &&
            (window.orientation === 90 || window.orientation === -90) &&
            window.innerWidth <= 800;
    }

    onOrientationChange = () => {
        this.setState({
            isInLandscape: this.isInLandscape()
        });
    }

    render() {
        if (this.state.isInLandscape) {
            return <MobileLandscapeMessage />
        } else if (isIE()) {
            return <IEOverlay />
        }

        switch (this.props.location[0]) {
            case 'admin':
            case 'location-manager':
                return <AdminPanel location={this.props.location} />;
            case 'location':
            default:
                return <Locator location={this.props.location} locationKey={this.props.location[1]} />;
        }

    }
}

function isIE() {
    const userAgent = window.navigator.userAgent;
    return userAgent.indexOf("MSIE") > -1 || userAgent.indexOf("Trident") > -1;
}

export default MainRouter;



// WEBPACK FOOTER //
// ./src/routers/MainRouter.js